<template>
    <div class="w-fit p-2 ml-3 mb-4 bg-base-100 border border-base-300">
        <input v-model="numNewEntities" class="bg-transparent outline-none" autocomplete="off">
        <button class="btn btn-primary btn-sm" :disabled="isLoading" @click="handleAddMany"> {{ isLoading ? 'Laster' : 'Opprett mange' }}</button>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {notifyError} from '@/services/infrastructure/notification.service'
import {useProducts} from '@/products/product.service'
import {generateProducts} from '@/dummy-generator/DummyGenerator.service'

const {fetchProducts} = useProducts()

const isLoading = ref(false)

const numNewEntities = ref(10)

const handleAddMany = async () => {
    isLoading.value = true
    try {
        await generateProducts(numNewEntities.value)
    } catch (error) {
        notifyError({title: 'Feilet', description: {descriptionMessage: `Klarte ikke å generere ${numNewEntities.value} produkter.`, error}})
    } finally {
        await fetchProducts()
        isLoading.value = false
    }
}
</script>

<style>

</style>